export default __webpack_public_path__ + "static/media/habibullah.4d7b7401.png";